<template>
  <img 
    :src="default_src"
    class="cpt-chat-img-lazy loadnig" 
    ref="img-dom" 
    :data-original="src" 
    alt=""
  >
</template>

<script>
export default {
  name: 'ChatImgLazy',
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      default_src: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
    }
  },
  mounted () {
    this.ele = this.$refs['img-dom']
    this.init()
  },
  watch: {
    src () {
      this.init()
    }
  },
  methods: {
    init() {
      if (this.ele.getAttribute('src') == this.default_src) {
        window.hcImg.observer.observe(this.ele)
      }
    }
  }
}
</script>

<style lang="scss">
.cpt-chat-img-lazy {
  opacity: 1;
  transition: opacity 0.2s;
  &[data-original] {
    opacity: 0;
  }
}
</style>